import isEqual from 'lodash/isEqual';
import React, { CSSProperties, memo } from 'react';
import { components } from 'react-select';
import AsyncSuggest from 'react-select/async';
import { LOADING_MESSAGE, NO_OPTIONS_MESSAGE } from '../../constants';
import { TSuggestFieldBodyProps } from '../SuggestField.interface';

// eslint-disable-next-line react/display-name
export const SuggestFieldBody = memo(
  (props: TSuggestFieldBodyProps): JSX.Element => {
    const {
      value,
      disabled,
      placeholder,
      optionLabelKey,
      optionValueKey,
      search: onSearch,
      customOption,
      onChange,
      valueContainer,
      noOptionsMessage,
      styles,
      openMenuOnClick,
      onInputChange,
      ...other
    } = props;

    let nullishValue = value;

    if (value === undefined) {
      nullishValue = null;
    }

    const componentOption = (props): JSX.Element => {
      const { data, children, ...propsOption } = props;

      return (
        <components.Option {...propsOption}>{customOption ? customOption(children, data) : children}</components.Option>
      );
    };

    const ValueContainer = (props) => {
      const { children } = props;

      return (
        <components.ValueContainer {...props}>
          {valueContainer ? valueContainer(props) : children}
        </components.ValueContainer>
      );
    };

    const NoOptionsMessage = (props): JSX.Element => (
      <components.NoOptionsMessage {...props}>
        {noOptionsMessage ? noOptionsMessage() : NO_OPTIONS_MESSAGE}
      </components.NoOptionsMessage>
    );

    const defaultStyles = {
      control: (base: CSSProperties) => ({
        ...base,
      }),
    };

    return (
      <AsyncSuggest
        styles={styles || defaultStyles}
        defaultOptions
        openMenuOnClick={openMenuOnClick}
        value={nullishValue}
        isDisabled={disabled}
        placeholder={placeholder}
        getOptionLabel={(option) => option[optionLabelKey]}
        getOptionValue={(option) => option[optionValueKey]}
        defaultValue={nullishValue}
        loadOptions={onSearch}
        loadingMessage={() => LOADING_MESSAGE}
        isClearable
        onChange={onChange}
        onInputChange={onInputChange}
        components={{ Option: componentOption, ValueContainer, NoOptionsMessage }}
        {...other}
      />
    );
  },
  (prevProps, nextProps) => !(prevProps.disabled !== nextProps.disabled || !isEqual(prevProps.value, nextProps.value)),
);
